export const SET_AUTH_INFO = 'setAuthInfo';
export const INITIALIZE_FROM_COOKIES_AC = 'initFromCookies';
export const CLEAR_AUTH_INFO = 'clearAuthInfo';
export const LOGOUT = 'logoutUser';
export const SET_REDIRECT_ACT = 'setRedirect';
